import { ThemeIcon } from "@mantine/core";
import { IconBell, IconReceipt } from "@tabler/icons-react";

const ICON_CONFIG: Record<string, { color: string; icon: React.ReactNode }> = {
  payment_review: { color: "blue", icon: <IconReceipt size={14} /> },
};

const DEFAULT_ICON_CONFIG = { color: "gray", icon: <IconBell size={14} /> };

export function TypeIcon({ type }: { type: string }) {
  const { color, icon } = ICON_CONFIG[type] ?? DEFAULT_ICON_CONFIG;
  return (
    <ThemeIcon size={28} variant="light" color={color} radius="xl" style={{ flexShrink: 0 }}>
      {icon}
    </ThemeIcon>
  );
}
